// Image responsive : WebP avec repli JPEG, dimensions explicites, lazy par défaut.
// srcSet/sizes = versions responsive (WebP) ; eager+priority pour l'image LCP.
export default function Img({ src, alt, width, height, className, eager = false, srcSet, sizes, priority = false }) {
  const webp = src.replace(/\.(jpe?g|png)$/i, ".webp");
  return (
    <picture>
      <source srcSet={srcSet || webp} sizes={srcSet ? sizes : undefined} type="image/webp" />
      <img
        src={src} alt={alt} width={width} height={height}
        sizes={srcSet ? sizes : undefined}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        decoding="async" className={className}
      />
    </picture>
  );
}
